var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcKitchenTickets({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H5.5C4.67 2 4 2.67 4 3.5V22.25C4 22.66 4.34 23 4.75 23H5.5C5.74 23 5.96 22.89 6.1 22.7L7.75 20.5L9.4 22.7C9.67 23.03 10.16 23.08 10.49 22.81C10.53 22.78 10.57 22.74 10.6 22.7L12.25 20.5L13.9 22.7C14.17 23.03 14.66 23.08 14.99 22.81C15.03 22.78 15.07 22.74 15.1 22.7L16.75 20.5L18.4 22.7C18.54 22.89 18.76 23 19 23H19.75C20.16 23 20.5 22.66 20.5 22.25V3.5C20.5 2.67 19.83 2 19 2ZM19 21L17.35 18.8C17.08 18.47 16.59 18.42 16.26 18.69C16.22 18.72 16.18 18.76 16.15 18.8L14.5 21L12.85 18.8C12.58 18.47 12.09 18.42 11.76 18.69C11.72 18.72 11.68 18.76 11.65 18.8L10 21L8.35 18.8C8.08 18.47 7.59 18.42 7.26 18.69C7.22 18.72 7.18 18.76 7.15 18.8L5.5 21V3.5H19V21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 4.9L14.7 4.88H14.2V16.27H15.2V12.3H16.35C16.83 12.3 17.23 11.9 17.23 11.42V7.56C17.23 6.08 16.46 5.11 15.2 4.91V4.9ZM16.23 11.29H15.2V5.93C15.88 6.09 16.23 6.64 16.23 7.55V11.29Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.31 4.87999H9.30996V9.58999H10.31V4.87999Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.33 4.87999V10.07H8.26996V4.87999H7.26996V10.19C7.26996 10.68 7.65996 11.07 8.14996 11.07H9.30996V16.26H10.31V11.07H11.45C11.94 11.07 12.33 10.68 12.33 10.19V4.87999H11.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKitchenTickets);
export default __webpack_public_path__ + "static/media/ic-kitchen-tickets.8192b4b2f53fd72027338f8c4d9c7a1c.svg";
export { ForwardRef as ReactComponent };